import React from 'react';
import { Box, ThemeProvider } from '@mui/material';
import Mast from './Mast';
import { jdTheme } from '../../styles/theme';
import BalingSection from './BalingSection';
import WebsiteSection from './WebsiteSection';
import Navbar from '../../components/Navbar';

const BalingPage: React.FC = () => {
  return (
    <Box
      sx={{
        background: jdTheme.palette.background.default,
        width: "100%",
      }}
    > 
    <ThemeProvider theme={jdTheme}>
      <Navbar />
      <Mast />
      <BalingSection />
      <WebsiteSection />
      </ThemeProvider>
    </Box>
  );
};

export default BalingPage;
